'use strict'
const _ = require('lodash')

function handleControllerConfigUpdate(messageData, {getAllApps}) {
    const {appDefinitionId, compId} = messageData
    const app = _.find(getAllApps(), ['appDefId', appDefinitionId])
    if (app) {
        const controllerToUpdate = _.find(app.controllersOnConfigUpdate, {compId})
        try {
            controllerToUpdate.onConfigUpdate(messageData.configUpdates)
        } catch (e) {
            // do nothing as this will only occur on page navigation and not when settings have been updated
            return
        }
    }
}

module.exports = handleControllerConfigUpdate

